var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.6,
    height: 74,
    viewBox: "0 0 75.6 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: -0.539,
    x2: 0.5,
    y2: 1.214,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24b377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d9d7c"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 8.183,
    width: 75.6,
    height: 52.736,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#10fc99",
    floodOpacity: 0.184
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    y1: -2.242,
    x2: 0.5,
    y2: 1.447,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f8158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24b377"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 4.267,
    y: 26.319,
    width: 34.51,
    height: 34.51,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#24b377",
    floodOpacity: 0.325
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.5,
    y1: -0.062,
    x2: 0.5,
    y2: 3.981,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24b377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.5,
    y1: -9.437,
    x2: 0.5,
    y2: 0.51,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6213be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24b377"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 34.913,
    y: 49.877,
    width: 24.123,
    height: 24.123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 18.6,
    y: 49.877,
    width: 24.123,
    height: 24.123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79.219 -70.674)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 79.22, 70.67)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.118,100.268H93.92a5.762,5.762,0,0,0-5.622,6.741h0a10.07,10.07,0,0,0,12.535,8.2l6.846-1.863a5.036,5.036,0,0,1,6.119,6.215l-.354,1.344A11.167,11.167,0,0,0,124.1,135h12.222a5.726,5.726,0,0,0,5.622-4.838l3.8-23.157A5.762,5.762,0,0,0,140.118,100.268Z",
    transform: "translate(-79.22 -83.08)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 79.22, 70.67)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.7,130.746,97.152,133.84a2.481,2.481,0,0,0-.45,4.625l4.146,2.033a2.484,2.484,0,0,1,1.136,1.136l2.033,4.146a2.481,2.481,0,0,0,4.625-.45l3.093-11.544A2.481,2.481,0,0,0,108.7,130.746Z",
    transform: "translate(-82.05 -95.34)",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.228 70.674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.969,85.739a2.2,2.2,0,0,1-2.2-2.2v-.069a8.381,8.381,0,1,0-16.763,0v.069a2.2,2.2,0,1,1-4.409,0v-.069a12.791,12.791,0,1,1,25.581,0v.069A2.2,2.2,0,0,1,138.969,85.739Z",
    transform: "translate(-115.592 -70.674)",
    fill: "url(#g)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.819 126.551)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.6, -55.88)",
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.062,
    cy: 3.062,
    r: 3.062,
    transform: "translate(43.91 55.88)",
    fill: "url(#h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.6, -55.88)",
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.062,
    cy: 3.062,
    r: 3.062,
    transform: "translate(27.6 55.88)",
    fill: "#24b377"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b37a99e5b60678c2ba7ef74f632642cc.svg";
export { ForwardRef as ReactComponent };